import isEmpty from 'lodash/isEmpty';
import pickBy from 'lodash/pickBy';
import isDate from 'lodash/isDate';
/**
 * Checks if a given value is empty or not.
 * @param value - The value to check.
 * @returns Returns true if the value is empty, otherwise false.
 * @description Values that are considered empty are:
 * - null
 * - undefined
 * - ''
 * - ' '
 * - []
 * - {}
 * - Empty Map
 * - Empty Set
 *
 * clarification: values such as true, false, 0 are NOT considered empty.
 */
export const isAnyTypeEmpty = (value: unknown) => {
  if (value === null || value === undefined) {
    return true;
  }

  if (typeof value === 'string' && value.trim() === '') {
    return true;
  }

  if (typeof value === 'number' || typeof value === 'boolean') {
    return false;
  }

  if (isDate(value)) {
    return false;
  }

  return isEmpty(value);
};

export const removeEmptyKeys = <T extends Record<string, unknown>>(obj: T): Partial<T> =>
  pickBy(obj, (value) => !isAnyTypeEmpty(value)) as Partial<T>;
